import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyAlertBar } from './components/StickyAlertBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { NewOpportunity } from './components/NewOpportunity';
import { Vision } from './components/Vision';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Objections } from './components/Objections';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-accent-rose selection:text-text-dark" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyAlertBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoints data-id="element-5" />
        <NewOpportunity data-id="element-6" />
        <Vision data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Objections data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FinalOffer data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}